import { Currency } from 'domains-billing-currency';
import { InvoiceType } from 'graphql-query-contracts';
import {
  Charge,
  INVOICEID_NO_INVOICE,
} from 'lane-shared/domains/billingPayments/types';

const PENDING_CHARGE_ID_PREFIX = 'charge_';

type PendingChargeParams = {
  draft: Charge;
  chargeId: string;
  name: string;
  amount: number;
  currency: Currency;
  invoiceType: InvoiceType;
  createdAt: Date;
};

export function pendingChargeFromDraft({
  draft,
  chargeId,
  name,
  amount,
  currency,
  invoiceType,
  createdAt,
}: PendingChargeParams): Charge {
  return {
    ...draft,
    id: `${PENDING_CHARGE_ID_PREFIX}${chargeId}`,
    name,
    status: 'PENDING',
    currency,
    amount,
    invoiceId:
      invoiceType === InvoiceType.InvoiceTypeNoInvoice
        ? INVOICEID_NO_INVOICE
        : '',
    createdAt,
  };
}

export const listedChargeId = (pendingCharge: Charge) =>
  pendingCharge.id.startsWith(PENDING_CHARGE_ID_PREFIX)
    ? pendingCharge.id.slice(PENDING_CHARGE_ID_PREFIX.length)
    : pendingCharge.id;
